import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/internal/operators';
import { ConfigTurnsService } from '../../../services/turns-services/config-turns-service/config-turns.service';
import { UserStorageService } from '../../../services/user-storage-service/user-storage.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-config-center-working-mode-card',
  templateUrl: './turns-config-center-working-mode-card.component.html',
  styleUrls: ['./turns-config-center-working-mode-card.component.scss']
})
export class TurnsConfigCenterWorkingModeCardComponent implements OnInit, OnDestroy {

  centers;
  workingModes;
  getTurnsCenterConfigSubscription: Subscription;
  updateTurnsCenterConfigSubscription: Subscription;

  basicDataForm = new FormGroup({
    selectedCenter: new FormControl(null),
    selectedWorkingMode: new FormControl(null)
  });

  constructor(private userStorageService: UserStorageService,
              private configTurnsService: ConfigTurnsService,
              private snackbarService: SnackBarService) {
    this.centers = this.userStorageService.getCenterList();
    this.workingModes = Object.values(TurnsConfigWorkingModesEnum);
  }

  ngOnInit() {
    this.basicDataForm.get('selectedWorkingMode').disable();
  }

  public loadWorkingModeForCenter() {
    if (!this.basicDataForm.get('selectedCenter').value) {
      this.clearWorkingMode();
      return;
    }

    this.basicDataForm.get('selectedWorkingMode').disable();
    this.basicDataForm.patchValue({
      selectedWorkingMode: null
    });

    this.getTurnsCenterConfigSubscription = this.configTurnsService.getTurnsCenterConfig(
      this.basicDataForm.get('selectedCenter').value.InternalId
    ).pipe(
      tap(o => {
        this.basicDataForm.patchValue({
          selectedWorkingMode: o && o['workingMode'] ? o['workingMode'] : null
        });
        this.basicDataForm.get('selectedWorkingMode').enable();
      }),
      catchError(error => {
        this.snackbarService.open(error['error']['message'], 'error');
        this.basicDataForm.get('selectedWorkingMode').enable();
        return EMPTY;
      })
    ).subscribe();
  }

  public updateWorkingMode() {
    if (!this.basicDataForm.get('selectedCenter').value) {
      return;
    }

    this.updateTurnsCenterConfigSubscription = this.configTurnsService.updateTurnsCenterConfig(
      this.basicDataForm.get('selectedCenter').value.InternalId,
      this.basicDataForm.get('selectedWorkingMode').value
    ).pipe(
      catchError(error => {
        this.snackbarService.open(error['error']['message'], 'error');
        return EMPTY;
      })
    ).subscribe();
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  private clearWorkingMode() {
    this.basicDataForm.patchValue({
      selectedWorkingMode: null
    });
    this.basicDataForm.get('selectedWorkingMode').disable();
  }

  ngOnDestroy() {
    if (this.getTurnsCenterConfigSubscription) { this.getTurnsCenterConfigSubscription.unsubscribe(); }
    if (this.updateTurnsCenterConfigSubscription) { this.updateTurnsCenterConfigSubscription.unsubscribe(); }
  }
}

export enum TurnsConfigWorkingModesEnum {
  'ONLINE' = 'ONLINE',
  'OFFLINE' = 'OFFLINE',
  'BOTH' = 'BOTH'
}
